import { List, Map } from "immutable";

export function getExisting<K, V>(map: Map<K, V>, keys: List<K>) {
  return keys.reduce(
    (found, key) => (map.has(key) ? found.set(key, map.get(key)) : found),
    Map()
  );
}

export function getMany<K, V>(map: Map<K, V>, keys: List<K>) {
  return keys.reduce((found, key) => found.set(key, map.get(key)), Map());
}

export function listExisting<K, V>(map: Map<K, V>, keys: List<K>): List<V> {
  return keys.reduce(
    (found, key) => (map.has(key) ? found.push(map.get(key)!) : found),
    List()
  );
}

export function listMany<K, V>(map: Map<K, V>, keys: List<K>) {
  return keys.map(key => map.get(key));
}
